var DevOps = "开发运营";
var Gaming = "游戏";
var Migration = "迁移";
var Other = "其他";
var useCase = {
	"Use case": "使用案例",
	"AI & machine learning": "人工智能 (AI) 与机器学习",
	"Batch processing": "批处理",
	"Big data, analytics, & business intelligence": "大数据、分析和商业智能",
	"Business applications - Microsoft": "业务应用程序 – Microsoft",
	"Business applications - Oracle": "业务应用程序 – Oracle",
	"Business applications - Other": "业务应用程序 – 其他",
	"Business applications - SAP": "业务应用程序 – SAP",
	"Content delivery": "内容分发",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "物联网",
	"Learning & certification": "学习和认证",
	"Media services": "媒体服务",
	Migration: Migration,
	"Mobile applications": "移动应用程序",
	Other: Other,
	"Storage & backup": "存储和备份",
	"Websites & web apps": "网站和 Web 应用程序"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
